import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmdOverlayComponent } from './overlay.component';
export class AmdOverlayModule {
}
AmdOverlayModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [AmdOverlayComponent],
                exports: [AmdOverlayComponent]
            },] },
];
/**
 * @nocollapse
 */
AmdOverlayModule.ctorParameters = () => [];
function AmdOverlayModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdOverlayModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdOverlayModule.ctorParameters;
}
//# sourceMappingURL=overlay.module.js.map
//# sourceMappingURL=overlay.module.js.map
